import * as types from './types';
import { SITESETUP_CLEAR_FETCHED } from '../types';

const INITIAL_STATE = {
  data: null,
  nutritionData: null,
  error: null,
  nutritionFetched: false,
  nutritionFetching: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SITESETUP_CLEAR_FETCHED:
      return {
        ...state,
        nutritionFetched: false,
      };

    case types.SITESETUP_SERVED_ITEMS_NUTRITION_FETCHING:
      return {
        ...state,
        nutritionFetching: action.payload,
      };

    case types.SITESETUP_GET_SERVED_ITEMS:
      return {
        ...state,
        data: action.payload.Data,
      };

    case types.SITESETUP_GET_SERVED_ITEMS_ERROR:
    case types.SITESETUP_GET_SERVED_ITEMS_NUTRITION_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case types.SITESETUP_GET_SERVED_ITEMS_NUTRITION:
      return {
        ...state,
        nutritionData: action.payload.Data,
        nutritionFetched: true,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/servedItems/reducer.js